import type { HowToProps } from '@/components/landing-page/components/how-to';
import Logos from '@/components/logos';
import OrderedList from '@/components/landing-page/components/ordered-list';
import { defaults } from '@/components/landing-page/components/how-to';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/how-to/how-to-v1.module.css';
import v2 from '@/components/landing-page/components/how-to/how-to-v2.module.css';

const HowTo = (props: HowToProps) => {
  const { title = defaults.title, list = defaults.list, className = defaults.className } = props;

  return (
    <div className={cn(v1.HowTo, v2.HowTo)}>
      <OrderedList title={title} list={list} className={className} />
      <Logos />
    </div>
  );
};

export default HowTo;
